export const errorMessageMixin = {
  methods: {
    errorMessage(err) {
      let errorMessage = "Unexpected error encountered. Please try again.";
      if (err.response && err.response.data.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }
      return errorMessage;
    }
  }
};